import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SettingsService } from '../sections/settings/settings.service';
import { UiModule } from '../ui/ui.module';

import { ProductBaseDetailComponent } from './common/product-base-detail/product-base-detail.component';
import { ProductBaseDetailService } from './common/product-base-detail.service';
import { LeftPanelModule } from './left-panel/left-panel.module';


@NgModule({
	imports: [
		CommonModule,
		LeftPanelModule,
		UiModule,
	],
	declarations: [ProductBaseDetailComponent],
	providers: [
		ProductBaseDetailService,
		SettingsService,
	],
})
export class ProductsModule { }
